import React, { useEffect, useMemo, useState } from 'react';
// Components
import RegularButton from 'components/CustomButtons/Button';
import GridContainer from 'components/Grid/GridContainer';
import Modal from 'components/Tvendo/Common/ModalBase';
import GridItem from 'components/Grid/GridItem';
import Table from 'components/Table/Table';
// Mui
import { Checkbox, TextField, Tooltip } from '@material-ui/core';
import { Restore } from '@material-ui/icons';
// Otros
import { wsGet, wsUpdate } from 'services/WService';

function PriceRetentionModal(props) {
  const { reload } = props;
  const [details, setDetails] = useState([]);
  const [processing, setProcessing] = useState(false);

  async function getDetails() {
    let res = await wsGet('logi/price-retention', props.model.id);
    if (res.success) {
      setDetails(
        res.data.details.map((detail) => ({
          ...detail,
          checked: true,
        })),
      );
    }
  }

  async function approve() {
    if (!window.confirm('¿Aprobar los precios?')) return;

    let detailsData = [];
    for (let detail of details) {
      let detailItem = {};
      if (detail.checked === false) {
        detailItem.state = 'A';
      }
      if ('update_unit_price' in detail) {
        // if(detail.update_unit_price ===)
        detailItem.unit_price = detail.update_unit_price;
      }

      if ('update_package_price' in detail) {
        detailItem.package_price = detail.update_package_price;
      }

      if (Object.keys(detailItem).length > 0) {
        detailItem.id = detail.id;
        detailsData.push(detailItem);
      }
    }
    let data = undefined;
    if (detailsData.length > 0) {
      data = { details: detailsData };
    }

    setProcessing(true);
    let res = await wsUpdate(`logi/price-retention/${props.model.id}/approve`, data);
    setProcessing(false);
    window.alert(res.message);
    if (res.success) {
      props.setOpen({ open: false });
      reload();
    }
  }

  async function annular() {
    if (!window.confirm('¿Anular la retención?')) return;

    setProcessing(true);
    let res = await wsUpdate(`logi/price-retention/${props.model.id}/refuse`);
    setProcessing(false);
    window.alert(res.message);
    if (res.success) {
      props.setOpen({ open: false });
      reload();
    }
  }

  useEffect(() => {
    if (props.model?.id === undefined) {
      setDetails([]);
      return;
    }
    getDetails();
  }, [props.model]);

  const [allChecked, indeterminate] = useMemo(() => {
    let allChecked = false;
    let indeterminate = false;
    let allCheckedLenght = details.filter((d) => d.checked === true).length;
    if (allCheckedLenght === details.length) {
      allChecked = true;
    } else if (allCheckedLenght > 0) {
      indeterminate = true;
    }
    return [allChecked, indeterminate];
  }, [details]);

  function handleCheckboxChange() {
    if (allChecked) {
      setDetails((details) => {
        let newDetails = [...details];
        newDetails = newDetails.map((d) => ({
          ...d,
          checked: false,
        }));
        return newDetails;
      });
      return;
    }
    if (!allChecked && !indeterminate) {
      setDetails((details) => {
        let newDetails = [...details];
        newDetails = newDetails.map((d) => ({
          ...d,
          checked: true,
        }));
        return newDetails;
      });
      return;
    }

    setDetails((details) => {
      let newDetails = [...details];
      newDetails = newDetails.map((d) => ({
        ...d,
        checked: false,
      }));
      return newDetails;
    });
  }

  function restorePrices() {
    setDetails((details) => {
      let newDetails = [...details];
      newDetails = newDetails.map((d) => {
        if ('update_unit_price' in d) {
          delete d.update_unit_price;
        }
        if ('update_package_price' in d) {
          delete d.update_package_price;
        }
        return d;
      });
      return newDetails;
    });
  }

  function redirectToPurchase() {
    let purchaseId = parseInt(props.model.generated_from.split('price/massive-update/purchase/')[1]);
    const url = `/admin/compras/operaciones/importaciones/${purchaseId}`;
    window.open(url, '_blank');
  }

  return (
    <Modal
      title="Retención de precios"
      maxWidth="lg"
      fullWidth
      model={props.model}
      setOpen={props.setOpen}
      entity=""
      hideSave
      hideClose
      footerComponent={
        <>
          <RegularButton
            color="success"
            onClick={approve}
            disabled={processing || (allChecked === false && indeterminate === false)}
          >
            Aprobar
          </RegularButton>
          <RegularButton color="danger" onClick={annular} disabled={processing}>
            Anular
          </RegularButton>
        </>
      }
    >
      <GridContainer>
        <GridItem xs={12}>
          <Tooltip title="Restaurar cambios">
            <RegularButton round justIcon color="warning" onClick={restorePrices}>
              <Restore />
            </RegularButton>
          </Tooltip>

          {!!props.model?.generated_from && props.model.generated_from.startsWith('price/massive-update/purchase/') && (
            <RegularButton color="primary" size="sm" onClick={redirectToPurchase}>
              Factura de compra
            </RegularButton>
          )}
        </GridItem>
        <GridItem xs={12}>
          <div style={{ maxHeight: '600px', overflow: 'auto' }}>
            <Table
              tableHead={[
                <>
                  <Checkbox
                    checked={allChecked}
                    indeterminate={indeterminate}
                    onChange={handleCheckboxChange}
                  />
                  #
                </>,
                'Producto',
                'Precio unitario',
                'P.Unit. antiguo',
                'Descuento',
                'Precio paquete',
                'P.Paq. antiguo',
              ]}
              tableData={details.map((detail, index) => {
                let originalDiscount =
                  detail.price?.discount !== undefined ? parseFloat(detail.price.discount) : 0;
                let discount =
                  detail.price?.discount !== undefined ? parseFloat(detail.price.discount) : 0;

                let unitPrice = parseFloat(
                  detail.update_unit_price || detail.unit_price || detail.previous_unit_price,
                );
                let unitChange = '';
                let previusUnitPrice = parseFloat(detail.previous_unit_price);
                if (unitPrice === previusUnitPrice) {
                  unitChange = `(Sin cambios)`;
                } else {
                  let percentage = Math.abs(
                    100 - parseFloat((100 * unitPrice) / previusUnitPrice),
                  ).toFixed(2);
                  if (unitPrice > previusUnitPrice) {
                    unitChange = `(+${percentage}%)`;
                  } else {
                    unitChange = `(-${percentage}%)`;
                  }
                }

                let packagePrice = parseFloat(
                  detail.update_package_price ||
                  detail.package_price ||
                  detail.previous_package_price,
                );
                let packageChange = '';
                let previusPackagePrice = parseFloat(detail.previous_package_price);

                // Si se actualiza el precio unitario, setear el paquete en base al descuento
                if (detail.package_price === null) {
                  packagePrice = unitPrice - unitPrice * (discount / 100);
                } else {
                  if (packagePrice === previusPackagePrice) {
                    packageChange = `(Sin cambios)`;
                  } else {
                    let percentage = Math.abs(
                      100 - parseFloat((100 * packagePrice) / previusPackagePrice),
                    ).toFixed(2);
                    if (packagePrice > previusPackagePrice) {
                      packageChange = `(+${percentage}%)`;
                    } else {
                      packageChange = `(-${percentage}%)`;
                    }
                  }
                }
                // Si se actualiza el precio paquete, se tiene que modificar el descuento
                if (detail.unit_price === null) {
                  discount = 100 - (100 * packagePrice) / parseFloat(detail.price.unit_price);
                }

                return [
                  <>
                    <Checkbox
                      checked={detail.checked}
                      onChange={() => {
                        setDetails((details) => {
                          let newDetails = [...details];
                          let index = newDetails.findIndex((item) => item.id === detail.id);
                          newDetails[index].checked = !newDetails[index].checked;
                          return newDetails;
                        });
                      }}
                    />
                    {index + 1}
                  </>,
                  `(${detail.product.ItemCode}) ${detail.product.ItemName}`,

                  <TextField
                    disabled={!detail.checked || detail.unit_price === null}
                    value={unitPrice}
                    fullWidth
                    type="number"
                    onChange={(e) => {
                      let value = e.target.value;
                      if (parseFloat(value) < 0 || parseFloat(value) === 0) return;
                      setDetails((details) => {
                        let newDetails = [...details];
                        let index = newDetails.findIndex((item) => item.id === detail.id);
                        newDetails[index].update_unit_price = value;
                        return newDetails;
                      });
                    }}
                  />,
                  `${previusUnitPrice.toFixed(6)} ${unitChange}`,
                  <>
                    <p>{parseFloat(originalDiscount).toFixed(2)}%</p>
                    <p>{parseFloat(discount).toFixed(2)}%</p>
                  </>,
                  <TextField
                    disabled={!detail.checked || detail.package_price === null}
                    value={packagePrice}
                    fullWidth
                    type="number"
                    onChange={(e) => {
                      let value = e.target.value;
                      if (parseFloat(value) < 0 || parseFloat(value) === 0) return;
                      setDetails((details) => {
                        let newDetails = [...details];
                        let index = newDetails.findIndex((item) => item.id === detail.id);
                        newDetails[index].update_package_price = value;
                        return newDetails;
                      });
                    }}
                  />,
                  `${previusPackagePrice.toFixed(6)} ${packageChange}`,
                ];
              })}
            />
          </div>
        </GridItem>
      </GridContainer>
    </Modal>
  );
}

export default PriceRetentionModal;
